import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=3f3dbbcc&scoped=true&"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=3f3dbbcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3dbbcc",
  null
  
)

export default component.exports